/* This script removes the "save (amount)" text in cart if savings are negative */
// kill-negative-save.js — FINAL HARD-LOCK
(function () {
  // ---------- helpers ----------
  function moneyToCents(txt) {
    const cleaned = (txt || "").replace(/[^0-9.\-]/g, "");
    if (!cleaned) return NaN;
    const n = Number(cleaned);
    return isFinite(n) ? Math.round(n * 100) : NaN;
  }
  function fmt(cents) {
    return (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  function isMoneyOnly(text) {
    return /^\s*(?:[A-Z]{3}\s*)?[$€£]?\s*\d[\d,]*\.?\d*\s*$/.test(text || "");
  }

  // Enforce exact text on a badge and nuke any extras (inside or after it)
  function enforceBadge(badge, saveCents) {
    if (!badge || !badge.isConnected) return;

    // If negative or zero, remove and stop.
    if (!(saveCents > 0)) { badge.remove(); return; }

    const desired = `(Save $${fmt(saveCents)})`;

    // 1) Force exact content INSIDE the badge
    if (badge.textContent !== desired) {
      badge.textContent = desired;
    }

    // 2) Remove any money-only siblings immediately after the badge
    let n = badge.nextSibling;
    // clean trailing whitespace and money-only text nodes
    while (n && n.nodeType === 3) {
      const s = n.textContent || "";
      if (!/\S/.test(s)) {
        const z = n; n = n.nextSibling; z.remove(); continue;
      }
      if (isMoneyOnly(s)) { n.remove(); }
      break;
    }
    // clean simple element siblings ($0.80 printed again)
    const p = badge.parentElement;
    if (p) {
      p.querySelectorAll(":scope > span, :scope > b, :scope > strong, :scope > i, :scope > em")
       .forEach((sib) => {
         if (sib === badge) return;
         const c = moneyToCents(sib.textContent);
         if (!isNaN(c) && c === saveCents) sib.remove();
       });
    }

    // 3) Guard against apps re-appending after we fix it:
    //    observe THIS badge and keep resetting if mutated.
    if (!badge._saveObserverAttached) {
      const mo = new MutationObserver(() => {
        // If someone jammed more nodes inside the same <span>, reset again.
        if (badge.textContent !== desired) badge.textContent = desired;
      });
      mo.observe(badge, { childList: true, characterData: true, subtree: true });
      badge._saveObserverAttached = true;
    }
  }

  // Compute savings for one ".price" box and sanitize its badge
  function processPriceBox(box) {
    if (!box) return;

    const badge = box.querySelector(".text-discount, .price .text-discount");
    if (!badge) return;

    // Kill explicit negative badge immediately
    const raw = (badge.textContent || "").trim();
    if (/\(\s*Save\s*-\$/.test(raw)) { badge.remove(); return; }

    const compare = box.querySelector(".line-through, .compare, .compare-at");
    const final   = box.querySelector(".font-medium, .final, .sale");
    if (!compare || !final) return;

    const cmp  = moneyToCents(compare.textContent);
    const sell = moneyToCents(final.textContent);
    if (isNaN(cmp) || isNaN(sell)) return;

    const save = cmp - sell;
    enforceBadge(badge, save);
  }

  // Run over main DOM and any shadow roots
  function runEverywhere() {
    // main document
    document.querySelectorAll(".price").forEach(processPriceBox);

    // shadow DOMs (cart drawer etc.)
    document.querySelectorAll("*").forEach((el) => {
      if (el.shadowRoot) {
        el.shadowRoot.querySelectorAll(".price").forEach(processPriceBox);
      }
    });
  }

  function start() {
    runEverywhere();
    // observe the whole page so AJAX/cart updates get sanitized
    new MutationObserver(runEverywhere)
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
